import type { Place, ServiceFee, SuburbanFeeData, Terminal } from "../../../../../my-type";
import { getSuburbanFeeData } from "../../../../../service/VehicleService";

export const calculateServiceFee = async (
  selectedPlace: Place,
  selectedTerminal: Terminal,
  serviceFeeData: ServiceFee[],
  teamCode: string
): Promise<{ isAddressInService: boolean; addServiceFee: number }> => {
  let isAddressInService = false;
  let regionBasicPrice = 0;
  let fartherPrice = 0;
  let fartherStreets: string[] = [];

  const airportID = selectedTerminal.code.substring(0, 3);
  console.log("airportID", airportID);

  for (const element of serviceFeeData) {
    console.log("element", element);
    if (element.airportID === airportID) {
      for (const priceElement of element.basicPrice) {
        console.log("basic price of element", priceElement);
        console.log("selectedPlace.firstLevel", selectedPlace.firstLevel);
        let foundIndex = priceElement.city.indexOf(selectedPlace.firstLevel);

        if (foundIndex !== -1) {
          console.log("found matching city:", selectedPlace.firstLevel);
          isAddressInService = true;

          let suburbanFeeData: SuburbanFeeData[] = await getSuburbanFeeData(
            selectedPlace.firstLevel,
            airportID,
            teamCode
          );

          console.log("suburbanFeeData", suburbanFeeData);

          if (suburbanFeeData?.length > 0) {
            console.log("selectedPlace.secondLevel", selectedPlace.secondLevel);
            const feeElement = suburbanFeeData[0].suburbanFee.find(
              element => element.region === selectedPlace?.secondLevel
            );
            console.log("feeElement", feeElement);
            if (feeElement) {
              fartherStreets = feeElement.fartherStreets;
              regionBasicPrice = feeElement.basicPrice;
              fartherPrice = feeElement.fartherPrice;
            }
          }

          break;
        }
      }
    }
  }

  if (!isAddressInService) {
    return { isAddressInService: false, addServiceFee: 0 };
  }

  // Check if road is in farther area
  let isRoadInFartherArea = false;
  fartherStreets.forEach(element => {
    if (selectedPlace.road.indexOf(element) !== -1) {
      isRoadInFartherArea = true;
    }
  });

  const addServiceFee = isRoadInFartherArea ? fartherPrice : regionBasicPrice;

  return { isAddressInService, addServiceFee };
};

export const calculateRouteTime = async (
  varRideAddress: string,
  varDestination: string,
  rideTime: Date,
  onComplete: (arriveTime: Date) => void
): Promise<void> => {
  const distanceMatrixService = new google.maps.DistanceMatrixService();
  const request = {
    origins: [varRideAddress],
    destinations: [varDestination],
    travelMode: google.maps.TravelMode.DRIVING
  };

  distanceMatrixService.getDistanceMatrix(request, function (result, status) {
    if (status === 'OK') {
      let varSeconds = rideTime.getSeconds() + result!.rows[0].elements[0].duration.value;
      let arriveTime = new Date(rideTime);
      arriveTime.setSeconds(varSeconds);
      onComplete(arriveTime);
    }
  });
};
